import Overview from '@rebuild/materials/shared/esg/FullIndex.vue';
import MobOverview from '@/rebuild/materials/shared/esg/mobile/MobOverview.vue';
import MobFull from '@/rebuild/materials/shared/esg/mobile/MobFull.vue';

export const componentMap = {
	overview: Overview,
	'mob-overview': MobOverview,
	'mob-full': MobFull
};
